import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

import { trackEvent } from '$/logger';

type State = {
  activeCategory: string | null;
};

type Actions = {
  selectCategory: (category: string | null) => void;
};

export const store = create<State & Actions>()((set, get) => ({
  ...{ activeCategory: null },
  selectCategory: (category) => {
    if (!category) {
      set({ activeCategory: null });
    } else {
      trackEvent('FilterInspiration', 'Roomtype', category);
      const alreadyActive = get().activeCategory === category;
      set({ activeCategory: alreadyActive ? null : category });
    }
  },
}));

export const useInspirationStore = createSelectorHooks(store);
